import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/** Normalize DB / UI content_order into ASC | DESC | CUSTOM for RPCs. */
export function normalizeFeedOrderType(raw: unknown): string {
  if (raw === false || raw === "false") return "ASC";
  if (raw === true || raw === "true") return "DESC";
  const s = String(raw ?? "")
    .trim()
    .toLowerCase();
  if (!s) return "DESC";
  if (s === "asc" || s.startsWith("asc ") || s === "oldest to newest") {
    return "ASC";
  }
  if (s === "custom" || s.startsWith("custom")) return "CUSTOM";
  if (s === "desc" || s.startsWith("desc ") || s === "newest to oldest") {
    return "DESC";
  }
  return "DESC";
}

/** Story RPCs often ignore order_type — sort client-side by post date. */
export function sortFeedRowsByPostDate(
  rows: unknown[],
  orderType: unknown,
): unknown[] {
  const normalized = normalizeFeedOrderType(orderType);
  if (normalized === "CUSTOM" || !Array.isArray(rows) || rows.length < 2) {
    return rows;
  }
  const asc = normalized === "ASC";
  const scored = rows.map((raw, i) => {
    const r =
      raw && typeof raw === "object"
        ? (raw as Record<string, unknown>)
        : ({} as Record<string, unknown>);
    const dateRaw =
      r.post_date ??
      r.posted_at ??
      r.created_at ??
      r.publish_date ??
      r.date ??
      r.timestamp;
    const ms = dateRaw ? dayjs.utc(String(dateRaw)).valueOf() : NaN;
    return {
      raw,
      i,
      ms: Number.isFinite(ms)
        ? ms
        : asc
          ? Number.POSITIVE_INFINITY
          : Number.NEGATIVE_INFINITY,
    };
  });
  scored.sort((a, b) => {
    if (a.ms !== b.ms) return asc ? a.ms - b.ms : b.ms - a.ms;
    return a.i - b.i;
  });
  return scored.map((s) => s.raw);
}
